export default __webpack_public_path__ + "static/media/card-lune.5f32fc86.png";